// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const SuzukiTheme = props => {
	useThemeStylesheet(() => import("./suzuki.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default SuzukiTheme;
